export default Object.freeze({
  StatusChanged: 'status-changed',
  StepChanged: 'step-changed',
  StepStatusChanged: 'step-status-changed',
  EvaluatedApprovers: 'evaluated-approvers',
  IRStatusChanged: 'iteration-result-status-changed',
  IRStepChanged: 'iteration-result-step-changed',
  IRStepStatusChanged: 'iteration-result-step-status-changed',
});
